import { Deserializable } from '../deserializable';
import {ThietBi} from '../danhmuc/thietbi';


export  class DangKy implements Deserializable
{
  public dangKyId: number;
  public ngay: string;
  public thoiGian: string;
  public noiDung: string;
  public nguoiChuTri: string;
  public phongID: number;
  public ghiChu: string;
  public nguoiDangKyID: number;
  public yeuCauTraLoi: string;
  public trangThai: number;
  public thoiGianDangKy: string;
  public logDangKy: string;
  public thietBi: ThietBi;
  public pheDuyet: string;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.thietBi= input.thietBi!= null?  new ThietBi().deserialize(input.thietBi) : null;
    return this;
  }
}
